import { render, staticRenderFns } from "./Box16.vue?vue&type=template&id=8dc3a662&scoped=true&"
import script from "./Box16.vue?vue&type=script&lang=js&"
export * from "./Box16.vue?vue&type=script&lang=js&"
import style0 from "./Box16.vue?vue&type=style&index=0&id=8dc3a662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc3a662",
  null
  
)

export default component.exports